import loadable from '@loadable/component';
import React from 'react';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "reviews" */ '../../../reviews')
);

const UserReviewsLoader = props => {
  // Data not loaded
  if (!props.pageInfo) {
    return null;
  }

  return <LoadableComponent {...props} />;
};

export default UserReviewsLoader;
